import { SvgIcon } from '@mui/material'

const WarningInfoIcon = ({ sx = {}, ...props }) => {
  return (
    <SvgIcon
      sx={{ fill: 'none !important', ...sx }}
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 4.1C10.2571 4.1 10.5085 4.17624 10.7222 4.31909C10.936 4.46194 11.1026 4.66497 11.201 4.90251C11.2994 5.14006 11.3252 5.40144 11.275 5.65362C11.2249 5.90579 11.101 6.13743 10.9192 6.31924C10.7374 6.50105 10.5058 6.62486 10.2536 6.67502C10.0014 6.72518 9.74006 6.69944 9.50251 6.60104C9.26497 6.50265 9.06194 6.33602 8.91909 6.12224C8.77624 5.90846 8.7 5.65712 8.7 5.4C8.7 5.05522 8.83696 4.72456 9.08076 4.48076C9.32456 4.23696 9.65522 4.1 10 4.1ZM13.2 14.9C13.2 15.1761 12.9761 15.4 12.7 15.4H7.7C7.42386 15.4 7.2 15.1761 7.2 14.9V14.3C7.2 14.0239 7.42386 13.8 7.7 13.8H9.4V9.4H8.3C8.02386 9.4 7.8 9.17614 7.8 8.9V8.3C7.8 8.02386 8.02386 7.8 8.3 7.8H10.5C10.7761 7.8 11 8.02386 11 8.3V13.8H12.7C12.9761 13.8 13.2 14.0239 13.2 14.3V14.9Z"
        fill="#E05D59"
      />
    </SvgIcon>
  )
}

export default WarningInfoIcon
